import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Stepper } from '@design-system-coopeuch/web';
import StyledMenu from './styles';
import { validarPath } from '../../../../utils/EncryptStorage';
import { rutasValidar } from '../../../../utils/RutasValidar';

const Menu = () => {
  const location = useLocation();
  if (rutasValidar.includes(location.pathname)) validarPath();
  const stepperPosicion = useSelector((store) => store.entities.stepper.menuPosicion);
  const casoBordeEstado = useSelector((store) => store.ui.casoBorde.casoBordeEstado);
  return (
    <>
      {!casoBordeEstado && (
        <StyledMenu>

          <div className="header-asistente">
            <h1>Solicitud de tarjeta de Crédito</h1>
            <p>Completa la información, conoce tu oferta y retira tu tarjeta de crédito en sucursal.</p>
          </div>

          <Stepper
            currentStep={stepperPosicion}
            steps={[
              {
                name: 'Verificación',
                step: 1
              },
              {
                name: 'Datos personales',
                step: 2
              },
              {
                name: 'Tu futura tarjeta',
                step: 3
              },
              {
                name: 'Sucursal',
                step: 4
              },
              {
                name: 'Comprobante',
                step: 5
              }
            ]}
          />
        </StyledMenu>
      )}
    </>
  )
}

export default Menu;